<script>
import fileUploadMixin from './fileUploadMixin';

export default {
  mixins: [fileUploadMixin],
  props: {
    knowledgebase: {
      type: Object,
      default: {},
    },
  },
  methods: {
    async onChange() {
      const file = this.$refs.file.files[0];
      const upload = await this.uploadFile(file, this.knowledgebase.id);
      await this.attachFile({
        file,
        upload,
        knowledgebaseId: this.knowledgebase.id,
      });
    },
  },
};
</script>

<template>
  <div>
    <input
      id="assetsFieldHandle"
      ref="file"
      type="file"
      multiple
      name="fields[assetsFieldHandle][]"
      class="w-px h-px opacity-0 overflow-hidden absolute hidden"
      accept=".pdf,.csv,.txt,.docx,.jpg,.jpeg,.png,.gif,.webp,.svg"
      aria-label="Upload files"
      @change="onChange"
    />
    <label
      for="assetsFieldHandle"
      class="button primary px-3.5 py-1 rounded-[5px] pointer cursor-pointer"
      aria-label="Upload files button"
    >
      <div class="flex flex-row">
        <span class="mr-2">
          <fluent-icon size="24" icon="upload" type="outline" />
        </span>
        {{ $t('LIBRARIES.RECORDS.UPLOAD.LABEL') }}
      </div>
    </label>
  </div>
</template>
